import { render } from "./BoqQuotationHeaderReadOnly.vue?vue&type=template&id=ce1178e4"
import script from "./BoqQuotationHeaderReadOnly.vue?vue&type=script&lang=js"
export * from "./BoqQuotationHeaderReadOnly.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__